import React from 'react';

class AttdModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            txtValue1: "",
            txtValue2: "",
            txtValue3: "",
            txtValue4: "",
            warningMsg: "",
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };
    componentWillMount() {

    }
    componentDidMount() {
        this.setState({
            txtValue1: this.props.timeIn,
            txtValue2: this.props.timeOut,
            txtValue3: this.props.startRemark,
            txtValue4: this.props.endRemark,
            warningMsg: "",
        });
    }

    handleChange(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let value = e.target.value;
        if (index == 0) {
            this.setState({ txtValue1: value });
        } else if (index == 1) {
            this.setState({ txtValue2: value });
        } else if (index == 2) {
            this.setState({ txtValue3: value });
        } else if (index == 3) {
            this.setState({ txtValue4: value });
        }
    }
    handleSubmit(e) {
        if (this.state.txtValue1 == "") {
            this.setState({ warningMsg: "Time In cannot be empty" });
        } else {
            this.setState({ warningMsg: "" });
            this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.txtValue3, this.state.txtValue4);
        }
    }
    modalClose() {
        this.props.shouldModalClose(false);
    }
    renderBody() {
        let body = "";
        body = (
            <div>
                <h4>{this.props.dateTxt}</h4>
                <form>
                    <label> time In</label>
                    <input className="form-control" type="time" data-index="0" onChange={this.handleChange} value={this.state.txtValue1} />
                </form>
                <form>
                    <label> time In Remark</label>
                    <input className="form-control" type="text" data-index="2" onChange={this.handleChange} value={this.state.txtValue3} />
                </form>
                <form>
                    <label> time Out</label>
                    <input className="form-control" type="time" data-index="1" onChange={this.handleChange} value={this.state.txtValue2} />
                </form>
                <form>
                    <label> time Out Remark</label>
                    <input className="form-control" type="text" data-index="3" onChange={this.handleChange} value={this.state.txtValue4} />
                </form>
            </div>
        );

        return (body);
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        let content;

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body" >
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderBody()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn " + (this.props.action == 3 ? " btn-danger" : "btn-warning")}
                            onClick={this.handleSubmit}>
                            {this.props.action == 3 ? "Remove" : "Update"}
                        </button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default AttdModal;


// WEBPACK FOOTER //
// ./app/components/attdComponents/attdModal.js